<template>
  <div class="flex flex-wrap">
    <div class="w-33.33% px-2 pt-2">
      <prime-button
        class="p-button-rounded p-2 md:px-3 w-full"
        :class="{
          'p-button-outlined': !model.includes(
            BetActivityTurnoverQualificationType.QUALIFIED
          )
        }"
        @click="onClick(BetActivityTurnoverQualificationType.QUALIFIED)"
      >
        <span class="text-xs md:text-sm mx-auto">
          {{ t('common.qualified') }}
        </span>
      </prime-button>
    </div>

    <div class="w-33.33% px-2 pt-2">
      <prime-button
        class="p-button-rounded p-2 md:px-3 w-full"
        :class="{
          'p-button-outlined': !model.includes(
            BetActivityTurnoverQualificationType.UNQUALIFIED
          )
        }"
        @click="onClick(BetActivityTurnoverQualificationType.UNQUALIFIED)"
      >
        <span class="text-xs md:text-sm mx-auto">
          {{ t('common.unqualified') }}
        </span>
      </prime-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BetActivityTurnoverQualificationType } from '@golden/gdk-agent-next'
import { useTypedI18n } from '@/functions/useTypedI18n'

const { t } = useTypedI18n()

const model = defineModel<BetActivityTurnoverQualificationType[]>({
  default: () => []
})

const onClick = (value: BetActivityTurnoverQualificationType) => {
  const index = model.value.indexOf(value)
  const newValue = [...model.value]

  if (index === -1) {
    newValue.push(value)
  } else {
    newValue.splice(index, 1)
  }

  model.value = newValue
}
</script>
